module.exports = __webpack_public_path__ + "img/pro.6f94b2de.webp";